export default __webpack_public_path__ + "static/media/bell.43ba89be.gif";